<style scoped>
  h4{ line-height: 60px;padding-left:20px; }
  .ivu-input-wrapper{ width: 80px;margin-right: 10px;margin-left: 10px; }
  section{ padding-left: 40px; }
  table{
    border-collapse:collapse;
    border-spacing:0;
    vertical-align: top;
  }
  table tr{ padding: 10px 0; }
  table td{
    word-break: break-all;
    word-wrap:break-word;
    padding: 10px;

  }
  .taxRateGroup{
    margin-bottom: 5px;
    display: flex;
    flex-flow: row;
    align-items: center;
  }
  .tishi{
    color: #808695;
    margin-bottom: 10px;
  }
</style>
<template>
  <div>
    <h4>提醒设置:</h4>
    <section>
      <table>
        <tr v-for="(item,index) in d_data" :key="index">
          <td>
            {{ index+1 }}. {{ item.Notes }}：
          </td>
          <td>
            <div v-if="item.Name=='TaxRate'">
              <div v-for="(item2,index2) in item.Value" :key="index2" >
                <!--5,6,13是国家规定一定会有的，所以不能删除,不给修改-->
                <div v-if="item2.Value==5 || item2.Value==6 || item2.Value==13" class="taxRateGroup">
                  <Input v-model="item2.Value" disabled >
                    <span slot="append">%</span>
                  </Input>
                </div>
                <div class="taxRateGroup" v-else>
                  <Input v-model="item2.Value">
                    <span slot="append">%</span>
                  </Input>
                  <Icon style="cursor: pointer" type="md-close" size="18" @click="delTaxRate(index,index2)" color="#ed4014"/>
                </div>
              </div>
            </div>
            <Input v-model="item.Value" v-else-if="item.Name=='EmptyAreaRate'">
              <span slot="append">%</span>
            </Input>
            <Input v-model="item.Value" v-else>
              <span slot="append">天</span>
            </Input>
          </td>
          <td >
            <p class="tishi" v-if="item.Name=='TaxRate'">温馨提示: 5,6,13 是国家规定税率，不予修改删除</p>
            <Button type="primary" @click="edit_submit(item.Name,item.Value,item.Notes,index)">设置</Button>
            <Button v-if="item.Name=='TaxRate'" type="primary" @click="addTaxRate(index)" style="margin-left: 10px;">添加</Button>
          </td>
        </tr>
      </table>
    </section>
  </div>
</template>
<script>
  import apiSystem from '@/api/system.js';
  export default {
    name:'systemSet_page',
    data(){
      return{
        params: {},
        d_data:[]
      }
    },
    methods:{
      pull_data() {
        let _this = this;
        apiSystem.getList.post(this.params).then((_data) => {
          if(_data.data.ExeSuccess && _data.data.LoginSuccess){ //登录成功+执行成功
            let requestResult = _data.data.Data;
            let rowsList =  requestResult.RowsList;
            let newRowList = [];
            for(let i=0;i<rowsList.length;i++){
              //  商铺文件保存路径不修改
              if(rowsList[i].Notes && rowsList[i].Name != 'ShopFileSavePath'){
                if(rowsList[i].Name === 'EmptyAreaRate'){ rowsList[i].Value = Number(rowsList[i].Value)*100 }
                if(rowsList[i].Name === 'TaxRate'){
                  let arrValue = rowsList[i].Value.split(',');
                  arrValue = arrValue.map(item=>{
                    return { Value:item }
                  })
                  rowsList[i].Value = arrValue;
                }
                newRowList.push(rowsList[i]);
              }
            }
            _this.d_data = newRowList;
          }else {
            this.$Message.error(_data.data.Msg);
          }
        });
      },
      edit_submit(_name,_value,_notes,_index){
        if(_name==='TaxRate'){
          for(let item of _value){
            item.Value = Number.parseFloat(Number(item.Value).toFixed(2));
          }
          let obj = {};
          _value = _value.reduce(function(item, next) {
                   obj[next.Value] ? '' : obj[next.Value] = true && item.push(next);
                   return item;
                }, []);
          this.d_data[_index].Value = _value;
          this.$Message.warning('税率自动去重');
          _value = _value.map(item=> item.Value)
          _value = _value.join();
        }
        if(_name==='EmptyAreaRate'){
          _value = Number(_value)/100;
        }
        let params = {
          Name: _name,
          Value: _value,
          Notes: _notes
        };
        let _this = this;
        setTimeout(function () {
          apiSystem.editcfg.post(params).then((_data) => {
            if(_data.data.ExeSuccess && _data.data.LoginSuccess){
              _this.$Message.success('设置成功！');
            }else {
              _this.$Message.error(_data.data.Msg);
            }
          });
        },1000)
      },
      addTaxRate(_index){
        this.d_data[_index].Value.push({
          Value:0
        })
      },
      delTaxRate(_index,_index2){
        this.d_data[_index].Value.splice(_index2,1);
      }
    },
    created() {
      this.params = JSON.parse(JSON.stringify(apiSystem.getList.data));
      this.pull_data();
    }
  }
</script>
